
  import Vue from 'vue'
  import { mapper } from '@/stores/store'
  import InfoButton from '@/components/IconButtons/InfoButton.vue'

  export default Vue.extend({
    components: { InfoButton },
    computed: {
      ...mapper([
        'downloading',
        'interacting',
        'footerVisible',
        'controlsScale'
      ]),
      buttonSize() {
        return 'sm'
      },
    },
    methods: {
      ...mapper(['showFooter'])
    },
  })
  